import { captureReferralFromUrl, getStoredReferral } from '../referralAttribution';

export type ResolvedReferral = {
  /** Code from ?ref / ?RefID / ?refid, else the stored ad/referral cookie. */
  referralCode: string;
  /** Label admin shows as "Referral Source". */
  referralSource: string;
  fromUrl: boolean;
  fromCookie: boolean;
};

/**
 * Generic "create a Qixit account" links carry ?ref=CODE. A code on the URL wins;
 * otherwise the referral cookie set by an earlier ad or referral click is used.
 */
export function resolveReferralFromContext(searchParams: URLSearchParams): ResolvedReferral {
  captureReferralFromUrl();
  const urlCode = (searchParams.get('ref') || searchParams.get('RefID') || searchParams.get('refid') || '').trim();
  const stored = getStoredReferral();
  const cookieCode = (stored?.ref || '').trim();
  const fromUrl = urlCode.length > 0;
  const fromCookie = !fromUrl && cookieCode.length > 0;

  let referralSource: string;
  if (fromUrl) {
    referralSource = searchParams.get('source') || 'UserReferral';
  } else if (fromCookie) {
    referralSource = stored?.utm_campaign ? `DisplayAd:${stored.utm_campaign}` : stored?.landing || 'DisplayAd';
  } else {
    referralSource = searchParams.get('source') || (typeof window !== 'undefined' ? window.location.href : 'Registration');
  }

  return { referralCode: urlCode || cookieCode, referralSource, fromUrl, fromCookie };
}
